import { States } from 'safe'
import {
  DELETE_MULTIPLE_DELIVERY_NOTES,
  SalesDeliveryNotesTypes,
  SET_SALE_PENDING_DELIVERY_NOTES,
} from '../actions/actionTypes'

const initialState: States.PendingDeliveryNotes = {
  pendingDeliveryNotes: [],
}

export default (
  state = initialState,
  action: SalesDeliveryNotesTypes
): States.PendingDeliveryNotes => {
  switch (action.type) {
    case SET_SALE_PENDING_DELIVERY_NOTES:
      return { ...action.payload }
    case DELETE_MULTIPLE_DELIVERY_NOTES:
      let copyValues = [...state.pendingDeliveryNotes]
      copyValues = copyValues.filter(
        (v) => !action.payload.some((x) => x === v.id)
      )
      return {
        ...state,
        pendingDeliveryNotes: copyValues,
      }
    default:
      return state
  }
}
